import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

function authConfig() {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function getWarehouseApSummary(scope) {
  const qs = scope === 'all' ? '?scope=all' : '';
  const res = await axios.get(`${API_URL}/api/warehouse-ap/summary${qs}`, authConfig());
  return res.data;
}

export async function getWarehouseApVendor(supplierId, currency, scope) {
  const params = new URLSearchParams();
  if (currency) params.set('currency', currency);
  if (scope === 'all') params.set('scope', 'all');
  const qs = params.toString() ? `?${params.toString()}` : '';
  const res = await axios.get(
    `${API_URL}/api/warehouse-ap/vendor/${encodeURIComponent(supplierId)}${qs}`,
    authConfig()
  );
  return res.data;
}
